import React from 'react';
import { Link } from 'react-router-dom';

const QuoteHeader = ({ request }) => {
  if (!request) return null;

  return (
    <div className="header-info">
      <Link to="/quote-requests" aria-label="Return to quote requests list">
        &larr; Back to Quote Requests
      </Link>
      <h1>{request?.name || `Quote Request #${request?.id}`}</h1>
      {request && (
        <div className="request-meta" role="group" aria-label="Quote request details">
          <span>Account Manager: {request.salesperson?.name || 'Not assigned'}</span>
          <span>
            Created:{' '}
            <time dateTime={request.date_created}>
              {request.date_created
                ? new Date(request.date_created).toLocaleDateString()
                : 'N/A'}
            </time>
          </span>
          <span>Status: {request.status}</span>
        </div>
      )}
    </div>
  );
};

export default QuoteHeader;